import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth-context";
import { DataProvider } from "./lib/data-context";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Lotes from "./pages/Lotes";
import Tabla from "./pages/Tabla";
import FichaLinea from "./pages/FichaLinea";
import Comparador from "./pages/Comparador";
import Escenarios from "./pages/Escenarios";
import Mapa from "./pages/Mapa";
import CargaDatos from "./pages/CargaDatos";
import Metodologia from "./pages/Metodologia";
import Inversion from "./pages/Inversion";
import Usuarios from "./pages/Usuarios";
import Calendarios from "./pages/Calendarios";
import Climatologia from "./pages/Climatologia";
import Planificacion from "./pages/Planificacion";
import PlanificacionFlota from "./pages/PlanificacionFlota";
import Login from "./pages/Login";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500 text-sm">
        Verificando sesión…
      </div>
    );
  }
  if (user === null) return <Navigate to="/login" replace />;
  return (
    <DataProvider>
      <Layout>{children}</Layout>
    </DataProvider>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/lotes" element={<Protected><Lotes /></Protected>} />
      <Route path="/tabla" element={<Protected><Tabla /></Protected>} />
      <Route path="/linea/:codigo" element={<Protected><FichaLinea /></Protected>} />
      <Route path="/comparador" element={<Protected><Comparador /></Protected>} />
      <Route path="/escenarios" element={<Protected><Escenarios /></Protected>} />
      <Route path="/inversion" element={<Protected><Inversion /></Protected>} />
      <Route path="/mapa" element={<Protected><Mapa /></Protected>} />
      <Route path="/carga" element={<Protected><CargaDatos /></Protected>} />
      <Route path="/calendarios" element={<Protected><Calendarios /></Protected>} />
      <Route path="/planificacion" element={<Protected><Planificacion /></Protected>} />
      <Route path="/planificacion-flota" element={<Protected><PlanificacionFlota /></Protected>} />
      <Route path="/climatologia" element={<Protected><Climatologia /></Protected>} />
      <Route path="/metodologia" element={<Protected><Metodologia /></Protected>} />
      <Route path="/usuarios" element={<Protected><Usuarios /></Protected>} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
